export default __webpack_public_path__ + "static/eco-sustainability_bg-5-2075d99ab9737eb34015456eafdd64bb.svg";